<template lang="pug">
ValidationProvider(
  v-slot="{ errors }"
  rules="required"
  name="work_break_policy_id"
  :model-value="workBreakPolicyId"
)
  .form-group(:class="{ 'has-error': errors[0] }")
    .row.margin-bottom-sm
      .col-sm-12
        .row
          .col-xs-6
            label.control-label.grouped_select {{ label }}
          .col-xs-6(v-if="allowIncludeAll")
            .control-label-btn.pull-right(v-if="multiOrganization")
              a(
                v-if="showCurrentOrganization"
                @click="setAllPolicies"
              ) Show all organizations
              a(
                v-else
                @click="setOrgPolicies"
              ) Hide other organizations
        AppSelect(
          ref="select"
          v-model="workBreakPolicyId"
          :disabled="disabled"
          :select2-options="getSelect2Options"
        )
    span.help-block {{ errors[0] }}
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'WorkBreakPolicySelect',
  props: {
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Policy*',
    },
    workBreakPolicyOptions: {
      type: Array,
      default: () => [],
    },
    allowIncludeAll: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  computed: {
    ...mapState(['showCurrentOrganization']),
    ...mapGetters(['organizations']),
    workBreakPolicyId: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      },
    },
    placeholder() {
      return 'Select a work break policy';
    },
    getSelect2Options() {
      return {
        allowClear: false,
        placeholder: this.placeholder,
        multiple: false,
        data: this.workBreakPolicyOptions.map((policy) => ({ text: policy.name, ...policy })),
        width: '100%',
      };
    },
    multiOrganization() {
      return this.organizations.length > 1;
    },
  },
  methods: {
    ...mapActions(['loadState']),
    setAllPolicies() {
      this.loadState({ showCurrentOrganization: false });
    },
    setOrgPolicies() {
      this.loadState({ showCurrentOrganization: true });
    },
  },
};
</script>
